'use client'

import type { MouseEvent, ReactNode } from 'react'

interface TocLinkProps {
  id: string
  className?: string
  children: ReactNode
}

// In-page link that scrolls to its heading smoothly (instantly for people who prefer reduced motion)
export function TocLink({ id, className, children }: TocLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(id)
    if (!target) return
    event.preventDefault()
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' })
    window.history.pushState(null, '', `#${id}`)
  }

  return (
    <a href={`#${id}`} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}
